import { createContext, useContext, type ReactNode } from 'react';

import { fetchPollsGateway } from '../api/fetchPollsGateway';
import type { PollsGateway } from '../ports/pollsGateway';

/**
 * Which backend the poll hooks talk to. It defaults to the real one, so the
 * app mounts no provider; a test mounts one holding an in-memory gateway.
 */
const PollsGatewayContext = createContext<PollsGateway>(fetchPollsGateway);

export function PollsGatewayProvider({
  gateway,
  children,
}: {
  gateway: PollsGateway;
  children: ReactNode;
}) {
  return <PollsGatewayContext.Provider value={gateway}>{children}</PollsGatewayContext.Provider>;
}

export function usePollsGateway() {
  return useContext(PollsGatewayContext);
}
